/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.server.refreshSession'

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.payload()

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.jsonPayload({
  accessJwt: /*#__PURE__*/ l.string(),
  refreshJwt: /*#__PURE__*/ l.string(),
  handle: /*#__PURE__*/ l.string({ format: 'handle' }),
  did: /*#__PURE__*/ l.string({ format: 'did' }),
  didDoc: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.lexMap()),
  email: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  emailConfirmed: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
  emailAuthFactor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
  active: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
  status: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string<{
      knownValues: ['takendown', 'suspended', 'deactivated']
    }>(),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Refresh an authentication session. Requires auth using the 'refreshJwt' (not the 'accessJwt'). */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, [
  'AccountTakedown',
  'InvalidToken',
  'ExpiredToken',
])

export { main }

export const $lxm = $nsid
